import ExtensionListTableComponent from "./extensionListTable.container";

export default ExtensionListTableComponent;
